var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUploadCheck = function SvgUploadCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90144 8.0908C2.70652 7.89588 2.70652 7.57986 2.90144 7.38494C3.09635 7.19003 3.41238 7.19003 3.60729 7.38494L5.85046 9.62811C6.04538 9.82303 6.04538 10.1391 5.85046 10.334C5.65554 10.5289 5.33952 10.5289 5.14461 10.334L2.90144 8.0908Z",
    fill: "#5FC068"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92125 10.3546C5.72633 10.5495 5.41031 10.5495 5.21539 10.3546C5.02048 10.1596 5.02048 9.84361 5.21539 9.6487L10.1564 4.70771C10.3513 4.51279 10.6673 4.51279 10.8622 4.70771C11.0572 4.90263 11.0572 5.21865 10.8622 5.41357L5.92125 10.3546Z",
    fill: "#5FC068"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UploadCheck.8e3d71eb.svg";
export { ForwardRef as ReactComponent };